import React, { useEffect, useState } from 'react';
import { getUpcomingEvents } from "../../../services/widgetsService";
 
function UpcommingEventsWidget() {
  const [events, setEvents] = useState([]);
  const [title, setTitle] = useState('');
  const [text, setText] = useState('');

  const getUpcomingEventsData = async () => {
    const { data } = await getUpcomingEvents();
    setEvents(data.events);
    setTitle(data.title);
    setText(data.text);
  }

  useEffect(() => {
    getUpcomingEventsData();
  }, []);

  return (
    <div>
      { events.length === 0
        ? ''
        : <div className="col-auto">    
          <div className='DashboardList-item btn d-flex flex-column'>
            <h4><i className="far fa-calendar-alt"></i>&nbsp;{title}</h4>
            <p>{text}</p>
            <ul>
            { events.map( (item, idx) => (
                <li key={idx}><a href={"events/" + item.id}>{item.name} - {item.department} - {item.start_date}</a></li>
              ) )
            }
            </ul>
          </div>
        </div>
      }
    </div>
  )
}

export default UpcommingEventsWidget;